/* ============================================================
   PebbleBloom™ — Mechanism
   File: assets/pb-mechanism.js

   Drives the staggered node entrance and the connector draw.

   Progressive enhancement, deliberately: the section ships with
   [data-pb-animate] and no animation class. This file promotes it
   to .pb-mech--animate — which is what applies opacity: 0 — and
   then adds .is-visible on scroll. If this file never loads, the
   hiding rule never applies and the section renders in full.
   ============================================================ */

(function () {
  'use strict';

  var SELECTOR = '[data-pb-animate="true"]';

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = root.querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(sections, function (el) {
      if (el.dataset.pbMechInit === '1') return;
      el.dataset.pbMechInit = '1';

      // No IntersectionObserver: leave it un-animated and fully visible
      // rather than opting into a hidden state we can never undo.
      if (!('IntersectionObserver' in window)) return;

      el.classList.add('pb-mech--animate');

      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          });
        },
        // threshold 0 + a negative bottom margin fires once the section
        // is meaningfully on screen, and stays correct when the section
        // is taller than the viewport (a ratio threshold would not).
        { threshold: 0, rootMargin: '0px 0px -15% 0px' }
      );

      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor re-renders the section on every setting change.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
